'use client';

import { Trans } from '@lingui/react/macro';
import { UIComponent } from '../..';
import { Link } from '../../atoms';
import { useDownloadApp } from '../download-app-modal/download-app-modal';

const FollowButton: UIComponent<{ isFollowed?: boolean }> = ({ isFollowed, as: Component = Link, ...props }) => {
  const openDownloadApp = useDownloadApp();
  return (
    <Component
      role="button"
      withEnterAsClick
      typography="default"
      as={Component === Link ? 'span' : undefined}
      {...props}
      onClick={() => {
        openDownloadApp('follow');
        // if (!isLogged) {
        //   toast.show(
        //     <span>
        //       <Trans>
        //         <Link as={InternalLink} href={links.login()}>
        //           Sign in
        //         </Link>{' '}
        //         to follow
        //       </Trans>
        //     </span>,
        //     {
        //       dismissable: true,
        //     },
        //   );
        //   return;
        // }
        // api.toggleFollow(user.id, !!user.isFollowed);
      }}
    >
      {isFollowed ? <Trans>Following</Trans> : <Trans>Follow</Trans>}
    </Component>
  );
};

export default FollowButton;
